module.exports = __webpack_public_path__ + "static/media/small-arrow.215b2a08.svg";